import { gql } from "@apollo/client";

export const AVAILABLE_EXPRESS_TIMES = gql`
  query availableTimesForVetTech($data: AvailableTimesInputV2!) {
    availableTimesForVetTech(
      data: $data
    ) {
      daysMonth {
        date,
        day,
        month,
        year,
        available,
        isNearestAvailableDay,
      },
      appointmentCreateType,
      availableTimes {
        date,
        times {
          time,
          resourcesId,
        },
        appointmentTypes {
          appointmentType,
          petId,
        }
      },
      location {
        idLocation,
        locationName,
        address,
        city,
        position {
          lat,
          lng,
        },
        email,
        phoneNumber,
        background,
      },
      timeZone,
      success,
      messages
    }
  }
`;
